/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */
import React from 'react';

import {FormUtils} from '@sonatype/nexus-ui-plugin';

import {NxFormGroup, NxTextInput, NxH2} from '@sonatype/react-shared-components';

import UIStrings from '../../../../../constants/UIStrings';

const {
  CAPTION,
  DISTRIBUTION: {LABEL, SUBLABEL}
} = UIStrings.REPOSITORIES.EDITOR.APT;

export default function AptDistributionConfiguration({parentMachine}) {
  const [parentState, sendParent] = parentMachine;

  return (
    <>
      <NxH2>{CAPTION}</NxH2>
      <NxFormGroup label={LABEL} sublabel={SUBLABEL} isRequired>
        <NxTextInput
          {...FormUtils.fieldProps('apt.distribution', parentState)}
          onChange={FormUtils.handleUpdate('apt.distribution', sendParent)}
          className="nx-text-input--long"
        />
      </NxFormGroup>
    </>
  );
}
